/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from 'react';
import './ContactSection.css';

function ContactSection() {
  return (
   <div>
    <section loading="eager" className="artiststop__section">
        <header>
          <h1>CONTACTO</h1>
        </header>
     </section>
    <div className="ct-content">
          <div className="contact-content">
          <div className="ct-head">
          {/* <h1>Contáctanos</h1> */}
            <span>Sólo consultas serias</span>
            <p className="intro">
              Si tienes alguna pregunta, no dudes en comunicarte con nosotros. <br>
              </br> Siempre estamos emocionados de conectarnos con artistas talentosos y profesionales en la industria.
            </p>
          </div>
            <div className="grid-container">
              <div className="grid-item">
                <div className="wd-content">
                <h3>MANAGEMENT</h3>
                  <ul>
                    <li>Joe - Mastered Trax</li>
                    <li>
                      <a href="tel:4084997909" title="">
                      (408) 499-7909
                      </a>
                    </li>
                    <li>
                      <a href="mailto:joe@masteredtrax.com" title="">
                      joe@masteredtrax.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="grid-item"></div>
              <div className="grid-item">
                <div className="wd-content centr">
                <h3><span role="img" aria-label="USA">🇺🇸</span> USA BOOKING</h3>
                  <ul>
                    <li>
                      <a href="mailto:booking@masteredtrax.com" title="">
                      booking@masteredtrax.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="grid-item"></div>
              <div className="grid-item">
                <div className="wd-content">
                <h3><span role="img" aria-label="Mexico">🇲🇽</span> MX BOOKING</h3>
                  <ul>
                    <li>SWAT</li>
                    <li>
                      <a href="tel:+523324328573" title="">
                      +52 33 243 285 73
                      </a>
                    </li>
                    <li>
                      <a href="mailto:press@masteredtrax.com" title="">
                      swat@masteredtrax.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
        </div>    
   </div>
  );
}

export default ContactSection;
